import type React from 'react'
import type { IconProps } from './types'

const NumberIcon: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M6 20L7 16H3L3.5 14H7.5L8.5 10H4.5L5 8H9L10 4H12L11 8H15L16 4H18L17 8H21L20.5 10H16.5L15.5 14H19.5L19 16H15L14 20H12L13 16H9L8 20H6ZM9.5 14H13.5L14.5 10H10.5L9.5 14Z' />
	</svg>
)

export default NumberIcon
